import React from "react";
import SocialIcon from "../SocialIcon/SocialIcon";
import { ContactWrapper, Email } from "./ContactElements";
function Contact() {
  return (
    <ContactWrapper id="contact">
      <div className="Container">
        <div className="SectionTitle">Get In Touch</div>
        <div className="BigCard">
          <Email>
            <span>abdulmajeed.alduaifi@gmail.com</span>
            <a
              className="btn PrimaryBtn"
              href="mailto:abdulmajeed.alduaifi@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Send Mail
            </a>
          </Email>
        </div>
        <div className="BigCard">
          <Email>
            <span>Phone Number: +966 560733052</span>
          </Email>
        </div>
      </div>
    </ContactWrapper>
  );
}

export default Contact;
